"use strict";
import { queryOptions } from "@tanstack/react-query";
import { ReactQueryCacheKey } from "utilities/src/reactQuery/cache";
export const getIsMismatchAccountQueryOptions = (ctx) => (input) => {
  return queryOptions({
    queryKey: [ReactQueryCacheKey.WalletCapabilities, input.address, input.chainId, ctx.isMainnet],
    queryFn: async () => {
      if (!input.address || !input.chainId) {
        return {
          chainId: input.chainId,
          hasMismatch: false
        };
      }
      const hasMismatch = await ctx.hasMismatch({ address: input.address, chainId: input.chainId });
      const result = {
        chainId: input.chainId,
        hasMismatch
      };
      return result;
    },
    enabled: !!input.address,
    refetchInterval: false,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: false,
    retry: false
  });
};
